import { Link } from 'react-router-dom'
import { ArrowRightIcon } from '@heroicons/react/24/outline'

import { Onboarding } from '../components/onboarding/Onboarding'
import { Dashboard } from '../components/personal/Dashboard'
import { SceneContainer } from '../components/scene/SceneContainer'
import { useCurrentWorkspace, useUserProfile } from '../store/hooks'
import { WorkspaceType } from '../lib/db/db.types'

const HomeScreen = () => {
  const { profile } = useUserProfile()
  const { myWorkspaces } = useCurrentWorkspace()

  if (!profile) return <div>Loading...</div>

  const isOnboardingComplete =
    typeof profile.name === 'string' &&
    typeof profile.selfAssessmentEnabled === 'boolean'

  const hasSetupBusinessWorkspace = myWorkspaces.some(
    (workspace) => workspace.spaceType === WorkspaceType.BUSINESS,
  )

  if (!isOnboardingComplete) {
    return <Onboarding />
  }

  return (
    <SceneContainer
      title={
        hasSetupBusinessWorkspace
          ? `Welcome back, ${profile.name}`
          : "Let's get everything set up"
      }
    >
      {hasSetupBusinessWorkspace ? (
        <Dashboard />
      ) : (
        <div className="flex flex-col items-center justify-center">
          <Link
            to="/new-business"
            className="inline-flex items-center justify-center w-full px-6 py-3 text-lg font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 transition-colors duration-300"
          >
            Find my business
            <ArrowRightIcon className="ml-2 h-5 w-5" />
          </Link>
        </div>
      )}
    </SceneContainer>
  )
}

export default HomeScreen
